/*=============================================== Button ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Variables from "./Variables";
import Mixins from "./Mixins";
import Icon from "./Icon";
import FajnyIcon from "./FajnyIcon";
import Loader from "./Loader";
/*==================== Component ====================*/
var Button = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "primary" : _b, _c = _a.buttonStyle, buttonStyle = _c === void 0 ? "plain" : _c, noPadding = _a.noPadding, iconLeft = _a.iconLeft, iconRight = _a.iconRight, fajnyIconLeft = _a.fajnyIconLeft, fajnyIconRight = _a.fajnyIconRight, disabled = _a.disabled, isLoading = _a.isLoading, children = _a.children, to = _a.to, _d = _a.type, type = _d === void 0 ? "button" : _d, props = __rest(_a, ["color", "buttonStyle", "noPadding", "iconLeft", "iconRight", "fajnyIconLeft", "fajnyIconRight", "disabled", "isLoading", "children", "to", "type"]);
    return (React.createElement(Container, __assign({ "$color": color, "$buttonStyle": buttonStyle, "$noPadding": noPadding, as: to ? Link : "button", to: to ? to : undefined, disabled: isLoading || disabled, type: !to ? type : undefined }, props),
        isLoading && React.createElement(Loader, { color: "gray", size: "xxs" }),
        iconLeft && React.createElement(Icon, { src: iconLeft, size: 16 }),
        fajnyIconLeft && React.createElement(FajnyIcon, { name: fajnyIconLeft, size: 16 }),
        children,
        iconRight && React.createElement(Icon, { src: iconRight, size: 16 }),
        fajnyIconRight && React.createElement(FajnyIcon, { name: fajnyIconRight, size: 16 })));
};
export default Button;
/*==================== Types ====================*/
var buttonStyles = {
    plain: "plain",
    text: "text",
    outline: "outline",
};
/*==================== Styles ====================*/
var Container = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    text-decoration: none;\n    padding: ", ";\n    ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    color: ", ";\n\n    @media ", " {\n        &:hover {\n            background-color: ", ";\n            color: ", ";\n            border-color: ", ";\n        }\n\n        &:active {\n            background-color: ", ";\n            color: ", ";\n            border-color: ", ";\n        }\n    }\n\n    &:disabled {\n        background-color: ", ";\n        color: ", ";\n        border-color: ", ";\n    }\n"], ["\n    border: 1px solid ", ";\n    text-decoration: none;\n    padding: ", ";\n    ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    color: ", ";\n\n    @media ", " {\n        &:hover {\n            background-color: ", ";\n            color: ", ";\n            border-color: ", ";\n        }\n\n        &:active {\n            background-color: ", ";\n            color: ", ";\n            border-color: ", ";\n        }\n    }\n\n    &:disabled {\n        background-color: ", ";\n        color: ", ";\n        border-color: ", ";\n    }\n"])), function (_a) {
    var $buttonStyle = _a.$buttonStyle;
    return ($buttonStyle === "outline" ? Mixins.ColorsHoverDefault : "transparent");
}, function (_a) {
    var $noPadding = _a.$noPadding;
    return ($noPadding ? 0 : "".concat(Variables.Spacers.XS, " ").concat(Variables.Spacers.S));
}, Mixins.Flexbox({
    $inline: true,
    $align: "center",
    $justify: "center",
    $gap: "xs",
}), Variables.Radiuses.M, function (_a) {
    var $buttonStyle = _a.$buttonStyle;
    return ($buttonStyle === "plain" ? Mixins.ColorsHoverDefault : "transparent");
}, function (_a) {
    var $buttonStyle = _a.$buttonStyle, $color = _a.$color;
    return $buttonStyle === "plain" && $color !== "white"
        ? Variables.Colors.White
        : $buttonStyle === "plain" && $color === "white"
            ? Variables.Colors.Primary500
            : Mixins.ColorsHoverDefault;
}, Variables.Breakpoints.Hover, function (_a) {
    var $buttonStyle = _a.$buttonStyle;
    return $buttonStyle === "plain" && Mixins.ColorsHoverHover;
}, function (_a) {
    var $buttonStyle = _a.$buttonStyle;
    return ($buttonStyle === "text" || $buttonStyle === "outline") && Mixins.ColorsHoverHover;
}, function (_a) {
    var $buttonStyle = _a.$buttonStyle;
    return $buttonStyle === "outline" && Mixins.ColorsHoverHover;
}, function (_a) {
    var $buttonStyle = _a.$buttonStyle;
    return $buttonStyle === "plain" && Mixins.ColorsHoverActive;
}, function (_a) {
    var $buttonStyle = _a.$buttonStyle;
    return ($buttonStyle === "text" || $buttonStyle === "outline") && Mixins.ColorsHoverActive;
}, function (_a) {
    var $buttonStyle = _a.$buttonStyle;
    return $buttonStyle === "outline" && Mixins.ColorsHoverActive;
}, function (_a) {
    var $buttonStyle = _a.$buttonStyle;
    return ($buttonStyle === "plain" ? Variables.Colors.Gray100 : "");
}, Variables.Colors.Gray500, function (_a) {
    var $buttonStyle = _a.$buttonStyle;
    return $buttonStyle === "outline" && Variables.Colors.Gray500;
});
var templateObject_1;
